/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IOrganAtRisk } from 'app/shared/model/organ-at-risk.model';
import { ITreatmentRadiation } from 'app/shared/model/treatment-radiation.model';

export interface ITreatmentOrganAtRisk {
  id?: string;
  exposureDose?: string | null;
  exposureDoseUnit?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  organ?: IOrganAtRisk | null;
  radiationSession?: ITreatmentRadiation | null;
}

export const defaultValue: Readonly<ITreatmentOrganAtRisk> = {
  active: false,
};
